var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.deviceClass, {'is-client': !_vm.logedUser}],style:(_vm.flexDirection),attrs:{"id":"app"}},[(_vm.logedUser)?_c('navigation'):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }